import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxEoWebComponentsModule } from 'ngx-eo-web-components';
import { PrimengModule } from './primeng.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxEoWebComponentsModule,
    PrimengModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    PrimengModule,
    NgxEoWebComponentsModule,
  ],
})
export class SharedModule {}
